/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

/**
* An org is to \"move\" if its parent org id is updated
*/
export class MoveOrgsRequest {
    'parentOrgId'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "parentOrgId",
            "baseName": "parent_org_id",
            "type": "string",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return MoveOrgsRequest.attributeTypeMap;
    }

    public constructor() {
    }
}

